<!-- eslint-disable vue/multi-word-component-names -->
<script>
import { mapMutations, mapActions, mapGetters } from 'vuex';
import QuestionAnswer from '/src/components/QuestionAnswer.vue'
import QuestionPage from '/src/components/QuestionPage.vue'
import { MDBBtn} from "mdb-vue-ui-kit";
import { mapFields } from "vuex-map-fields";

export default {
  components: {
    QuestionAnswer,
    QuestionPage,
    MDBBtn,
  },
  computed: {
    ...mapFields([
      'scene.status.holiday'
    ]),
    ...mapGetters([
      'getQuestionAnswerData'
    ]),
    questionAnswerData() {
      return this.getQuestionAnswerData('holiday')
    }
  },
  methods: {
    ...mapMutations([
      'selectHolidayStatus',
      'goToNextPage',
      'moveToItem'
    ]),
    ...mapActions([
      'goToItem',
    ]),
    chooseBasic: function () {
      this.selectHolidayStatus(1);
      this.holiday = 1
    },
    chooseMedium: function () {
      this.selectHolidayStatus(2);
      this.holiday = 2
    },
    chooseTop: function () {
      this.selectHolidayStatus(3);
      this.holiday = 3
    }
  },
};
</script>
<template>
  <QuestionPage :title="questionAnswerData.question">
    <Transition name="switch" mode="out-in" appear>
      <div v-if="holiday < 2"
        class="question_image question_image_holiday-basic d-block d-sm-none"
      ></div>
      <div v-else-if="holiday == 2"
        class="question_image question_image_holiday-medium d-block d-sm-none"
      ></div>
      <div v-else-if="holiday == 3"
        class="question_image question_image_holiday-top d-block d-sm-none"
      ></div>
    </Transition>

    <!-- show on desktop only -->
    <QuestionAnswer
      :title="questionAnswerData.answers.A"
      class='d-none d-sm-block'
      :onSelect="chooseBasic"
      @click="goToItem('holiday')"
      :imageName="questionAnswerData.images.Q7AA"
    />
    <QuestionAnswer
      :title="questionAnswerData.answers.B"
      class='d-none d-sm-block'
      :onSelect="chooseMedium"
      @click="goToItem('holiday')"
      :imageName="questionAnswerData.images.Q7AB"
    />
    <QuestionAnswer
      :title="questionAnswerData.answers.C"
      class='d-none d-sm-block'
      :onSelect="chooseTop"
      @click="goToItem('holiday')"
      :imageName="questionAnswerData.images.Q7AC"
    />

    <!-- on mobile only -->
    <div class='d-flex d-sm-none questions-on-mobile'>
      <QuestionAnswer
        :title="questionAnswerData.answers.A"
        :isSelected="holiday == 1"
        :onSelect="chooseBasic"
      />
      <QuestionAnswer
        :title="questionAnswerData.answers.B"
        :isSelected="holiday == 2"
        :onSelect="chooseMedium"
      />
      <QuestionAnswer
        :title="questionAnswerData.answers.C"
        :isSelected="holiday == 3"
        :onSelect="chooseTop"
      />
      <MDBBtn class="next-btn-on-mobile" @click="moveToItem('holiday')">next</MDBBtn>
    </div>
  </QuestionPage>
</template>

